<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzExpenseStatus === 'Y'
              ? 'success'
              : row.amzExpenseStatus === 'S'
              ? 'warning'
              : row.amzExpenseStatus === 'D' ||
                row.amzExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_amzExpenseStatus }}
        </el-tag>
      </template>
       <template v-slot:createByName="{ row }">
        <span>
          {{ row.createByName }}
        </span>
        <br />
        <span>
          {{ row.createTime }}
        </span>
      </template>
      <template v-slot:modifyByName="{ row }">
        <span>
          {{ row.modifyByName }}
        </span>
        <br />
        <span>
          {{ row.modifyTime }}
        </span>
      </template>
      <template v-slot:substituteInvoice="{ row }">
        <el-tag
          size="mini"
          :type="row.substituteInvoice === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_substituteInvoice }}
        </el-tag>
      </template>
      <template v-slot:forwardGeneralManager="{ row }">
        <el-tag
          size="mini"
          :type="row.forwardGeneralManager === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_forwardGeneralManager }}
        </el-tag>
      </template>
      <template v-slot:businessConsumption="{ row }">
        <el-tag
          size="mini"
          :type="row.businessConsumption === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_businessConsumption }}
        </el-tag>
      </template>
      <template v-slot:otherSet="{ row }">
        <el-tag size="mini" :type="row.otherSet === '1' ? 'danger' : 'primary'">
          {{ row.v_otherSet }}
        </el-tag>
      </template>
      <template v-slot:showAmount="{ row }">
        <span> {{ row.currencyAmount }} {{ row.currencyUnit }}</span>
      </template>
      <template v-slot:payeeCustName="{ row }">
        <span v-if="row.payeeType == 'C'">{{ row.payeeCustName }}</span>
        <span v-else>{{ row.payeeScmName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.show == undefined ? true : opt.show(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { amzExpenseCode, amzExpenseNo } = data
      const params = { code: amzExpenseCode }
      const query = { amzExpenseNo: amzExpenseNo }
      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: params,
            query: query,
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'approval':
          this.oaAudit(data)
          break
      }
    },
    del({ amzExpenseCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .ecomAmzExpenseDelApi({ amzExpenseCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    async oaAudit({ amzExpenseCode }) {
      let title = this.$l('INDEX.tips_submit_review') || '是否提交审核？'
      this.$confirm(title, this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText:
          this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
      }).then(async () => {
        const linkUrl = this.$joinURL(
          `/opview/amzExpense/${amzExpenseCode}`,
          { joinOrigin: true, joinBasePath: false }
        )
        this.loadingOpen()
        await this.$api
          .oaEcomAmzExpenseApplyApi({ amzExpenseCode, linkUrl })
          .then(async () => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('INDEX.tips_submission_failed') || '提交失败！'
            )
          })
      })
    },
  },
}
</script>
